<script lang="ts">
  function greeting(d: Date = new Date()): string {
    const h = d.getHours();
    if (h < 5) return "Late swim";
    if (h < 12) return "Good morning";
    if (h < 18) return "Good afternoon";
    return "Good evening";
  }

  // Time-of-day captured at mount. Re-renders when the component re-mounts
  // (i.e., when the Swim tab is re-entered); deliberately not reactive on
  // each second — the greeting band shouldn't flip mid-session.
  const g = greeting();
</script>

<section class="hero">
  <div class="line line-greet">{g}.</div>
  <div class="line line-call">Break the horizon.</div>
</section>

<style>
  .hero {
    padding: var(--space-3) var(--space-1);
    /* Fully opaque (DESIGN.md's literal bg-card #1B1B1D, not the Dawn-Glass
       rgba variant): tested at every alpha from 0.42 up to 0.95 and the
       detector's worst-pixel backdrop-filter sample never moved — any
       translucency at all leaves this measurement mode active. Opaque is the
       only thing that actually clears it, same call as the pre-existing
       showcase-ribbon override (app.css) for the same reason.
       backdrop-filter: none is the other half — app.css's global
       `#app-root section[class]` rule still applies blur(22px) to this
       section, which is pointless once the background is opaque, and the
       blur itself is what kept the detector's pixel sample locked onto the
       backdrop photo instead of the painted background above. !important
       because that global rule is ID-scoped (beats a plain component class). */
    background: #1B1B1D;
    backdrop-filter: none !important;
    -webkit-backdrop-filter: none !important;
    border-radius: var(--radius-card);
  }
  .line {
    line-height: 1.2;
    letter-spacing: -0.01em;
  }
  .line-greet {
    font: var(--type-title-subtitle);
    color: var(--text-muted);
  }
  .line-call {
    /* Empty-state hero: the one display element when there's no swim yet.
       Bumped to display-large (32px) so the no-data screen still leads the eye
       with a clear jump above the muted greeting line. */
    font: var(--type-display-large);
    color: var(--text-primary);
    margin-top: var(--space-1);
  }
</style>
